module.exports = __webpack_public_path__ + "img/offline.e8a3d76b.svg";